import React from 'react';
import { Checkbox } from 'antd';
import type { CargoItemRes, CargoRes } from 'api/swagger';
import { useSelectCargoStore } from 'shared/stores/use-select-cargos.ts';

interface ICargoItemCheckboxProps {
  cargo: CargoRes;
  cargoItem: CargoItemRes;
}

export const CargoItemCheckbox: React.FC<ICargoItemCheckboxProps> = ({ cargoItem, cargo }) => {
  const { setSelectedCargoItem, deleteSelectedCargoItem, selectedCargoItems } = useSelectCargoStore();

  const isSelected = selectedCargoItems.has(cargoItem.id);

  const handleClick = () => {
    if (isSelected) {
      deleteSelectedCargoItem(cargoItem);
    } else {
      setSelectedCargoItem(cargoItem, cargo);
    }
  };

  return <Checkbox checked={isSelected} onClick={handleClick} /*disabled={isParentSelected}*/ />;
};
